module.exports = __webpack_public_path__ + "static/blue-d3075b1de05045a9c16e6ce30dd475c6.png";